import { useQuery } from '@tanstack/react-query'
import { fetchRegion } from '@/services/regions'

export function useRegion(id: string | undefined) {
  const regionQuery = useQuery({
    queryKey: ['region', id],
    queryFn: () => fetchRegion(id!),
    enabled: !!id,
  })

  return {
    region: regionQuery.data,
    isLoading: regionQuery.isLoading,
    error: regionQuery.error,
  }
}
